import React from 'react';
import { Route } from 'react-router';
import Employee, {
  Role as EmployeeRole,
  Staff as EmployeeStaff,
  Pin as EmployeePin,
} from 'pages/Employees';
import createCustomRoute from 'hocs/createCustomRoute';

const EmployeeRoutes = createCustomRoute('EmployeeRoutes', props => (
  <Route {...props} component={Employee}>
    <Route path="role" component={EmployeeRole} />
    <Route path="staff" component={EmployeeStaff} />
    <Route path="pin" component={EmployeePin} />
  </Route>
));

export default EmployeeRoutes;
